// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleUseTheFact_root__3wiV9","text":"ToggleUseTheFact_text__2x3kA","active":"ToggleUseTheFact_active__3UDDZ"};